import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import Switch from "@mui/material/Switch";
import { Controller } from "react-hook-form";

interface SwitchInput {
  name: string;
  label: string;
  defaultValue?: boolean;
}

interface SwitchGroupInputProps {
  defaultValue?: boolean;
  inputs: SwitchInput[];
  label?: string;
  row?: boolean;
  labelPlacement?: "start" | "end" | "top" | "bottom";
}

export const SwitchGroupInput = ({
  label,
  defaultValue,
  inputs,
  row,
  labelPlacement
}: SwitchGroupInputProps) => {
  return (
    <FormControl fullWidth>
      {label && <FormLabel>{label}</FormLabel>}
      <FormGroup row={row}>
        {inputs.map((input) => (
          <Controller
            key={input.name}
            name={input.name}
            defaultValue={input.defaultValue ?? defaultValue}
            render={({ field: { value, onChange } }) => (
              <FormControlLabel
                control={<Switch checked={value} onChange={onChange} />}
                label={input.label}
                labelPlacement={labelPlacement}
                sx={{
                  mb: 1,
                  ...(label ? {} : { ml: 0 })
                }}
              />
            )}
          ></Controller>
        ))}
      </FormGroup>
    </FormControl>
  );
};
